var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "12px",
    viewBox: "0 0 13 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "329268AF-3DD7-4880-BFB8-776B207E267F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "91.944385%",
    y1: "86.2137299%",
    x2: "6.13903743%",
    y2: "15.3669616%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A0A63",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16B8EF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Compliance-Relationship-Details",
    transform: "translate(-117.000000, -652.000000)",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(107.851460, 508.905839)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(0.000000, 82.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder-(2)",
    transform: "translate(9.208726, 61.332836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.16863581,10.3343281 L11.3476813,10.3343281 C11.9931645,10.333221 12.515949,9.8098377 12.5163171,9.16435365 L12.5163171,7.16080587 C12.5163171,7.0314262 12.4114341,6.92654325 12.2820545,6.92654325 C12.1526748,6.92654325 12.0477918,7.0314262 12.0477918,7.16080587 L12.0477918,9.16421979 C12.0477189,9.55106685 11.7345275,9.86485708 11.3476813,9.865669 L1.16863581,9.865669 C0.781789596,9.86485708 0.468598198,9.55106685 0.468525238,9.16421979 L0.468525238,1.16984059 C0.468671808,0.783023992 0.781820198,0.469276847 1.16863581,0.468391374 L5.75215128,0.468391374 C5.95148372,0.46955623 6.13596147,0.573980468 6.23955139,0.744285807 C6.24914003,0.759644903 6.25772527,0.775608079 6.26525335,0.792075381 L6.76550444,1.83273687 C6.93834467,2.19269851 7.30191028,2.42202051 7.70121627,2.4229448 L11.3476813,2.4229448 C11.7341582,2.42338742 12.0473492,2.73657847 12.0477918,3.12305537 L12.0477918,4.89943535 C12.0477918,5.02881502 12.1526748,5.13369796 12.2820545,5.13369796 C12.4114341,5.13369796 12.5163171,5.02881502 12.5163171,4.89943535 L12.5163171,1.71734579 C12.5155055,0.980587728 11.9184475,0.383529717 11.1816895,0.382718187 L6.55614059,0.382718187 C6.35870011,0.141539814 6.0638376,0.0011781912 5.75215128,0 L1.16863581,0 C0.523152606,0.00110707197 0.000368109605,0.524490405 0,1.16997445 L0,9.16435365 C0.000368109605,9.8098377 0.523152606,10.333221 1.16863581,10.3343281 L1.16863581,10.3343281 Z M11.1816895,0.851377289 C11.6598105,0.851893739 12.0472754,1.23935861 12.0477918,1.71747966 L12.0477918,2.18961923 C11.8462536,2.03708499 11.6004348,1.95450301 11.3476813,1.95441956 L7.70121627,1.95441956 C7.48222782,1.95396677 7.28283248,1.82818073 7.1881142,1.63073556 L6.81329401,0.851377289 L11.1816895,0.851377289 Z M12.5163171,5.97035017 L12.5163171,6.08734762 C12.5163171,6.21672729 12.4114341,6.32161024 12.2820545,6.32161024 C12.1526748,6.32161024 12.0477918,6.21672729 12.0477918,6.08734762 L12.0477918,5.97035017 C12.0477918,5.8409705 12.1526748,5.73608756 12.2820545,5.73608756 C12.4114341,5.73608756 12.5163171,5.8409705 12.5163171,5.97035017 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.3df4eb34d02123d1f3e68c9b06be1209.svg";
export { ForwardRef as ReactComponent };